document.addEventListener('DOMContentLoaded', function () {
    const bottomNav = document.createElement('div');
    bottomNav.className = 'bottom-nav_pdm';

    bottomNav.innerHTML = `
      <div class="menu-icon_pdm">
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_3626_176)">
            <path d="M3.75 14.5H20.25" stroke="#1D2A2C" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.75 6.5H20.25" stroke="#1D2A2C" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.75 22.5H20.25" stroke="#1D2A2C" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_3626_176">
              <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
            </clipPath>
          </defs>
        </svg>
      </div>
      <button id="contactPopup" class="contact-cta-mobile2 button button--primary">
        Contact Us
      </button>
    `;

    document.body.appendChild(bottomNav);

    const menuIcon = bottomNav.querySelector('.menu-icon_pdm');
    const detailsMenu = document.getElementById('Details-menu-drawer-container');

    const handleMenuInteraction = () => {
        if (detailsMenu) {
            const summaryElement = detailsMenu.querySelector('summary');
            if (summaryElement) {
                summaryElement.click(); 
            } else {
                console.error('Elemento summary no encontrado dentro de detailsMenu.');
            }
        } else {
            console.error('Elemento detailsMenu no encontrado.');
        }
    };

    if (menuIcon) {
        menuIcon.addEventListener('click', handleMenuInteraction);
    }
    const contactPopup = bottomNav.querySelector('#contactPopup');
    if (contactPopup) {
        contactPopup.addEventListener('click', function (event) {
            event.preventDefault();
            window.open(
                'https://erpoxcd11ey.typeform.com/to/n9VqELlM',
                'popupWindow',
                'width=600,height=800,scrollbars=yes,resizable=yes'
            );
        });
    }
});
